import {Injectable} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
declare var ga: Function;

@Injectable()
export class GoogleAnalyticsService {

  constructor(public router: Router) {
    this.router.events.subscribe(event => {
      try {
        if (typeof ga === 'function') {
          if (event instanceof NavigationEnd) {
            ga('set', 'page', event.urlAfterRedirects);
            ga('send', 'pageview');
          }
        }
      } catch (e) {
        console.log(e);
      }
    });

  }

  public emitEvent(eventCategory: string,
   eventAction: string,
   eventLabel: string = null,
   eventValue: number = null) {
    if (typeof ga === 'function') {
      ga('send', 'event', {
        eventCategory: eventCategory,
        eventLabel: eventLabel,
        eventAction: eventAction,
        eventValue: eventValue
      });
    }
  }

  productView(productData){
      if (typeof ga === 'function') {
          ga('ec:addImpression', {
            'id': productData.item_id,
            'name': productData.title,
            'list': 'Product viewed',
            'category': productData.catalogue_code,
            'dimension1': productData.display_uom
          });
      }
  }
  productSearch(productData){
      if (typeof ga === 'function') {
          ga('ec:addImpression', {
            'id': productData.id,
            'name': productData.name,
            'list': productData.list
          });
      }
  }
  productSearchByAttribute(productData){
      if (typeof ga === 'function') {
          ga('ec:addImpression', {
            'id': productData.id,
            'name': productData.name,
            'list': productData.list,
            'category':productData.category
          });
      }
  }
  
   addToCart(product,flag) {
    ga('ec:addProduct', {
      'id': product.item_id,
      'name': product.title,
      'price': product.price.data.price.amount_excl_val,
      'quantity': product.cart.data.qty
    });
    ga('ec:setAction', flag);
    ga('send', 'event', 'UX', 'click', 'add to cart');     // Send data using an event.
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/services/google-analytics.service.ts